var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueglassAnnouncement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3707 5.2465V0.742815C13.3707 0.332573 13.0381 0 12.6278 0H11.885C10.4153 1.46976 7.653 2.29328 5.94252 2.68365V10.687C7.653 11.0774 10.4153 11.9009 11.885 13.3707H12.6278C13.0381 13.3707 13.3707 13.0381 13.3707 12.6278V8.12416C14.0114 7.95926 14.4849 7.37756 14.4849 6.68533C14.4849 5.9931 14.0114 5.4114 13.3707 5.2465ZM1.48563 2.97126C0.665138 2.97126 0 3.6364 0 4.45689V8.91378C0 9.73429 0.665138 10.3994 1.48563 10.3994H2.22844L2.97126 14.1135H4.45689V2.97126H1.48563Z",
    fill: "#5260F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueglassAnnouncement);
export default __webpack_public_path__ + "static/media/blueglass-announcement.c3e3f287213473b2a7328cb955d18d96.svg";
export { ForwardRef as ReactComponent };